import { render, staticRenderFns } from "./PercentageOrDollars.vue?vue&type=template&id=006f45c7&scoped=true&"
import script from "./PercentageOrDollars.vue?vue&type=script&lang=js&"
export * from "./PercentageOrDollars.vue?vue&type=script&lang=js&"
import style0 from "./PercentageOrDollars.vue?vue&type=style&index=0&id=006f45c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f45c7",
  null
  
)

export default component.exports